import { Backpack, Bike, Camera, Mountain, Snowflake, Tent, type LucideIcon } from 'lucide-react';
import { photo } from '@/lib/utils/img';
import { brand } from '@/lib/theme/tokens';

export type KitCategoryKey = 'vehicles' | 'skis' | 'clothing' | 'camping' | 'photo' | 'climbing';

export type KitCategory = {
  key: KitCategoryKey;
  name: string;
  tagline: string;
  intro: string;
  icon: LucideIcon;
  color: string;
  image: string;
  to: string;
};

export const KIT_CATEGORIES: KitCategory[] = [
  { key: 'vehicles',  name: 'Vehicles',       tagline: 'Bikes, SUVs, snowmobiles, ATVs.',      intro: 'Mountain-tuned. Tank-full pickup. Real insurance.',              icon: Bike,       color: brand.chinar,   image: photo.road,        to: '/vehicles' },
  { key: 'skis',      name: 'Ski & snow',      tagline: 'Skis, boots, goggles, avalanche kit.', intro: 'Verbier-grade equipment with Gulmarg-tuned bindings.',           icon: Snowflake,  color: brand.ice,      image: photo.skier,       to: '/trailkit/skis' },
  { key: 'clothing',  name: 'Clothing',        tagline: 'Jackets, base layers, gloves, boots.',  intro: 'Goretex shells, merino base, Vibram boots — sized to you.',     icon: Backpack,   color: brand.teal,     image: photo.snowPeaks,   to: '/trailkit/clothing' },
  { key: 'camping',   name: 'Camping',         tagline: 'Tents, sleeping bags, stoves, mats.',  intro: 'Cold-night gear that actually keeps you warm at 4,000 m.',     icon: Tent,       color: brand.saffron,  image: photo.campingTent, to: '/trailkit/camping' },
  { key: 'photo',     name: 'Photo & drone',   tagline: 'Drones, action cams, tripods, glass.', intro: 'DJI, Sony, GoPro. Insured, calibrated, ready to go.',           icon: Camera,     color: brand.ok,       image: photo.aerialPeaks, to: '/trailkit/photo' },
  { key: 'climbing',  name: 'Climbing & ice',  tagline: 'Harnesses, ropes, axes, crampons.',    intro: 'UIAA-certified, inspected after every rental.',                 icon: Mountain,   color: brand.cobalt,   image: photo.cliff,       to: '/trailkit/climbing' },
];

export const FEATURED_KIT = {
  name: 'Black Diamond Harness',
  image: 'photo-1527004013197-933b977977e2',
  pricePerDay: 550,
};
